import { IconButton, Stack } from "@mui/material";
import { AudioRecorder, useAudioRecorder } from 'react-audio-voice-recorder';
import DeleteIcon from '@mui/icons-material/Delete';
import React, { useState } from "react";

//Audio recorder for chat
//used react-audio-voice-recorder lib
//function sendVoice calls after finishing recording

export default function ChatVoiceRecorder({ sendVoice }) {

    const [cancel, setCancel] = useState(false)

    const recorderControls = useAudioRecorder()
    const addAudioElement = (blob) => {
        if(!cancel) {
            sendVoice(blob)
        } else {
            setCancel(false)
        }
    }

    return (
        <Stack direction="row">
            <AudioRecorder
                onRecordingComplete={(blob) => addAudioElement(blob)}
                recorderControls={recorderControls}
                showVisualizer={true}
                downloadOnSavePress={false}
            />
            {
                recorderControls.isRecording &&
                <IconButton sx={{marginRight: "4rem !important"}} size="small" onClick={() => {setCancel(true); recorderControls.stopRecording()}}>
                    <DeleteIcon sx={{color: "white"}} />
                </IconButton>
            }
        </Stack>
    )
}